export class Updated<T> {
  constructor(readonly previous: T, readonly current: T) {}

  map<R>(transform: (value: T) => R): Updated<R> {
    return new Updated(transform(this.previous), transform(this.current))
  }
}
